function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import has from 'lodash/has';
import each from 'lodash/each'; // A counter used to generate a unique id for each component that uses the function

var idCount = 0;
var SCRIPT_MAP = {};
/*
 The commented out logic is logic not supported by IE10 or IE11. I left as a reference
 in case issues occur with the polyfills.
*/

export default function makeAsyncScript(Component, scriptURL) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var funcs = {
    displayName: 'AsyncScriptLoader',
    propTypes: {
      asyncScriptOnLoad: PropTypes.func
    },
    statics: {
      asyncScriptLoaderTriggerOnScriptLoaded: function asyncScriptLoaderTriggerOnScriptLoaded() {
        var mapEntry = SCRIPT_MAP[scriptURL];

        if (!mapEntry || !mapEntry.loaded) {
          throw new Error('Script is not loaded.');
        } // for (let observer of _.values(mapEntry.observers)) {
        //     observer(mapEntry);
        // }


        each(mapEntry.observers, function (observer) {
          return observer(mapEntry);
        });
        delete window[options.callbackName];
      }
    },
    getInitialState: function getInitialState() {
      return {};
    },
    asyncScriptLoaderGetScriptLoaderID: function asyncScriptLoaderGetScriptLoaderID() {
      if (!this.__scriptLoaderID) {
        this.__scriptLoaderID = "async-script-loader-".concat(idCount++);
      }

      return this.__scriptLoaderID;
    },
    getComponent: function getComponent() {
      return this.childComponent;
    },
    componentDidMount: function componentDidMount() {
      var _this = this;

      var key = this.asyncScriptLoaderGetScriptLoaderID();
      var globalName = options.globalName,
          callbackName = options.callbackName;

      if (globalName && typeof window[globalName] !== 'undefined') {
        SCRIPT_MAP[scriptURL] = {
          loaded: true,
          observers: {}
        };
      }

      if (has(SCRIPT_MAP, scriptURL)) {
        var entry = SCRIPT_MAP[scriptURL];

        if (entry && (entry.loaded || entry.errored)) {
          this.asyncScriptLoaderHandleLoad(entry);
          return;
        }

        entry.observers[key] = this.asyncScriptLoaderHandleLoad;
        return;
      }

      var observers = {};
      observers[key] = this.asyncScriptLoaderHandleLoad;
      SCRIPT_MAP[scriptURL] = {
        observers: observers,
        loaded: false
      };
      var script = document.createElement('script');
      script.src = scriptURL;
      script.async = 1;

      var callObserverFuncAndRemoveObserver = function callObserverFuncAndRemoveObserver(func) {
        if (has(SCRIPT_MAP, scriptURL)) {
          var mapEntry = SCRIPT_MAP[scriptURL];
          var observersMap = mapEntry.observers;
          var newMap = {}; // for (let [obsKey, observer] of observersMap) {
          //     if (func(observer)) {
          //         observersMap.delete(obsKey);
          //     }
          // }

          each(observersMap, function (observer, observerKey) {
            if (!func(observer)) {
              newMap[observerKey] = observer;
            }
          });
          mapEntry.observers = newMap;
        }
      };

      if (callbackName && typeof window !== 'undefined') {
        //eslint-disable-next-line
        window[callbackName] = AsyncScriptLoader.asyncScriptLoaderTriggerOnScriptLoaded;
      }

      script.onload = function () {
        var mapEntry = SCRIPT_MAP[scriptURL];

        if (mapEntry) {
          mapEntry.loaded = true;
          callObserverFuncAndRemoveObserver(function (observer) {
            if (callbackName) {
              return false;
            }

            observer(mapEntry);
            return true;
          });
        }
      };

      script.onerror = function () {
        var mapEntry = SCRIPT_MAP[scriptURL];

        if (mapEntry) {
          mapEntry.errored = true;
          callObserverFuncAndRemoveObserver(function (observer) {
            observer(mapEntry);
            return true;
          });
        }
      }; // (old) MSIE browsers may call 'onreadystatechange' instead of 'onload'


      script.onreadystatechange = function () {
        if (_this.readyState === 'loaded') {
          // wait for other events, then call onload if default onload hadn't been called
          window.setTimeout(function () {
            var mapEntry = SCRIPT_MAP[scriptURL];

            if (mapEntry && mapEntry.loaded !== true) {
              script.onload();
            }
          }, 0);
        }
      };

      document.body.appendChild(script);
    },
    asyncScriptLoaderHandleLoad: function asyncScriptLoaderHandleLoad(state) {
      this.setState(state, this.props.asyncScriptOnLoad);
    },
    componentWillUnmount: function componentWillUnmount() {
      // Remove tag script
      if (options.removeOnUnmount === true) {
        var allScripts = document.getElementsByTagName('script');

        for (var i = 0; i < allScripts.length; i += 1) {
          if (allScripts[i].src.indexOf(scriptURL) > -1) {
            if (allScripts[i].parentNode) {
              allScripts[i].parentNode.removeChild(allScripts[i]);
            }
          }
        }
      } // Clean the observer entry


      var mapEntry = SCRIPT_MAP[scriptURL];

      if (mapEntry) {
        // mapEntry.observers.delete(this.asyncScriptLoaderGetScriptLoaderID());
        var scriptLoaderId = this.asyncScriptLoaderGetScriptLoaderID();
        delete mapEntry.observers[scriptLoaderId];

        if (options.removeOnUnmount === true) {
          // SCRIPT_MAP.delete(scriptURL);
          delete SCRIPT_MAP[scriptURL];
        }
      }
    },
    render: function render() {
      var _this2 = this;

      var globalName = options.globalName; //eslint-disable-next-line

      var _this$props = this.props,
          asyncScriptOnLoad = _this$props.asyncScriptOnLoad,
          childProps = _objectWithoutProperties(_this$props, ["asyncScriptOnLoad"]);

      if (globalName && typeof window !== 'undefined') {
        childProps[globalName] = typeof window[globalName] !== 'undefined' ? window[globalName] : undefined;
      } //eslint-disable-next-line


      return React.createElement(Component, _extends({
        ref: function ref(comp) {
          _this2.childComponent = comp;
        }
      }, childProps));
    }
  };

  if (options.exposeFuncs) {
    // for (let funcToExpose of options.exposeFuncs) {
    //   /* eslint-disable no-loop-func */
    //     funcs[funcToExpose] = function() {
    //         return this.childComponent[funcToExpose](...arguments);
    //     };
    //   /* eslint-enable no-loop-func */
    // }
    each(options.exposeFuncs, function (funcToExpose) {
      funcs[funcToExpose] = function () {
        var _this$childComponent;

        //eslint-disable-next-line
        return (_this$childComponent = this.childComponent)[funcToExpose].apply(_this$childComponent, arguments);
      };
    });
  }

  var AsyncScriptLoader = createReactClass(funcs);
  return AsyncScriptLoader;
}